import {
  formatVoiceLabel,
  formatVoiceLabelToUpperCase,
} from '@app/modules/logger/screens/stream/components/audit/transcriptions/utils';
import { useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { PopoverActions, PopoverContent, PopoverHelp, PopoverMessageContainer } from './styled';

import { Button, Input } from '@mui/material';
import Popover from '@mui/material/Popover';

interface SpeakerInputProps {
  speaker: string;
  onSave: (speaker: string) => void;
  onReplaceAll: (new_voice_label: string, label: string) => void;
}

export function SpeakerInput({ speaker, onSave, onReplaceAll }: SpeakerInputProps) {
  const [speakerBuffer, setSpeakerBuffer] = useState<string>(
    formatVoiceLabelToUpperCase(formatVoiceLabel(speaker)),
  );
  const inputRef = useRef<HTMLInputElement>(null);
  const { formatMessage } = useIntl();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const tooltipHelp = formatMessage({
    id: 'fragments.wordEditor.tooltipHelp',
    defaultMessage: 'Presiona enter para guardar o escape para cancelar',
  });

  const handleCancel = () => {
    setSpeakerBuffer(formatVoiceLabelToUpperCase(formatVoiceLabel(speaker)));
    handleClose();
  };

  const handleReplace = () => {
    onSave(speakerBuffer);
    handleClose();
  };

  const handleReplaceAll = () => {
    onReplaceAll(speakerBuffer, speaker);
    handleClose();
  };

  return (
    <>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: -30,
          horizontal: 'left',
        }}
      >
        <PopoverContent>
          <PopoverMessageContainer>
            <PopoverHelp>{tooltipHelp}</PopoverHelp>
            <Input
              ref={inputRef}
              type="text"
              value={speakerBuffer}
              style={{ width: '100%' }}
              onChange={(e) => setSpeakerBuffer(e.target.value)}
            />
          </PopoverMessageContainer>
          <PopoverActions>
            <Button size="small" variant="outlined" onClick={handleCancel}>
              <FormattedMessage id="common.cancel" defaultMessage="Cancelar" />
            </Button>
            <Button size="small" variant="outlined" onClick={handleReplaceAll}>
              <FormattedMessage
                id="fragments.transcription.replaceAll"
                defaultMessage="Replace all"
              />
            </Button>
            <Button size="small" variant="contained" onClick={handleReplace}>
              <FormattedMessage id="fragments.transcription.replace" defaultMessage="Replace" />
            </Button>
          </PopoverActions>
        </PopoverContent>
      </Popover>
      <span onClick={handleClick}>{speakerBuffer}</span>
    </>
  );
}
